import { useParams } from '@tanstack/react-router'

const useIsGlobalOrg = (): boolean => {
  const params: unknown = useParams({ strict: false })
  const orgId =
    typeof params === 'object' && params !== null && 'orgId' in params ? params.orgId : undefined

  return Number(orgId) === Number(import.meta.env.VITE_TUKIOS_FLOWERS_ORG_ID)
}

export default useIsGlobalOrg
